import initialState from "../initialState";
import { InitialState, WalletActions, GET_BALANCE } from "../types";

const walletReducer = (
  state = initialState.walletState,
  action: WalletActions
): InitialState["walletState"] => {
  switch (action.type) {
    case GET_BALANCE: {
      return {
        ...state,
        address: action.payload.address,
        balance: action.payload.balance,
        confirmations: action.payload.confirmations,
      };
    }
    default:
      return state;
  }
};

export default walletReducer;
